import { render } from "./DropArea.vue?vue&type=template&id=3bafd2dc&ts=true"
import script from "./DropArea.vue?vue&type=script&lang=ts"
export * from "./DropArea.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2533167813/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__